import React, { useContext, useEffect, useRef, useState } from "react";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import toastError from "../../errors/toastError";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl }) => {
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const menuRef = useRef(null);
  const { user } = useContext(AuthContext);
  const isGroupTicket = ticket.isGroup === true;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && menuOpen) {
        handleClose();
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen, handleClose]);

  const handleDeleteTicket = async () => {
    try {
      await api.delete(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenConfirmationModal = () => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleOpenTransferModal = () => {
    setTransferTicketModalOpen(true);
    handleClose();
  };

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false);
  };

  if (!menuOpen) {
    return (
      <>
        <ConfirmationModal
          title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
            ticket.id
          } ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
            ticket.contact.name
          }?`}
          open={confirmationOpen}
          onClose={setConfirmationOpen}
          onConfirm={handleDeleteTicket}
        >
          {i18n.t("ticketOptionsMenu.confirmationModal.message")}
        </ConfirmationModal>
        <TransferTicketModal
          modalOpen={transferTicketModalOpen}
          onClose={handleCloseTransferTicketModal}
          ticketid={ticket.id}
          ticketWhatsappId={ticket.whatsappId}
        />
      </>
    );
  }

  return (
    <>
      <div
        ref={menuRef}
        className="absolute right-0 top-full mt-1 z-50 min-w-[160px] bg-white dark:bg-dark-800 border border-dark-200 dark:border-dark-700 rounded-lg shadow-lg py-1"
      >
        {/* Não mostrar opção de transferir para grupos */}
        {!isGroupTicket && (
          <button
            onClick={handleOpenTransferModal}
            className="w-full px-4 py-2 text-left text-sm text-dark-700 dark:text-dark-200 hover:bg-dark-100 dark:hover:bg-dark-700 transition-colors"
          >
            {i18n.t("ticketOptionsMenu.transfer")}
          </button>
        )}
        <Can
          role={user.profile}
          perform="ticket-options:deleteTicket"
          yes={() => (
            <button
              onClick={handleOpenConfirmationModal}
              className="w-full px-4 py-2 text-left text-sm text-red-600 dark:text-red-400 hover:bg-dark-100 dark:hover:bg-dark-700 transition-colors"
            >
              {i18n.t("ticketOptionsMenu.delete")}
            </button>
          )}
        />
      </div>
      <ConfirmationModal
        title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
          ticket.id
        } ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
          ticket.contact.name
        }?`}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteTicket}
      >
        {i18n.t("ticketOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <TransferTicketModal
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferTicketModal}
        ticketid={ticket.id}
        ticketWhatsappId={ticket.whatsappId}
      />
    </>
  );
};

export default TicketOptionsMenu;
